import theme from '../../../muiTheme';
import { flexCentered, flexColumnCentered } from '../../../styles';

const styles = {

    rootContainer: {
        ...flexColumnCentered,
        minHeight: '100vh',
        height: 'auto',
        width: '100vw',
        '.intro-edit-container': {
            ...flexColumnCentered,
            justifyContent: 'space-evenly',
            minHeight: '400px',
            textAlign: 'center',
            

        },

        '& .progress-title': {
            fontSize: '24px',
            marginBottom: '40px',
            marginTop: '15px',
            position: 'static',
            top: '70px',
            textAlign: 'center',
            background: '#72d972',
            color: 'white',
            borderRadius: '20px',
            padding: '15px',
            
            [theme.breakpoints.down('sm')]: {
                marginTop: '15px',
                marginBottom: '15px',
                fontSize: '18px',
                top: '10px',
                padding: '10px',
                paddingTop: '60px',
                borderRadius: '0px 0px 15px 15px',
                
            }

        },

        '& .edit-title': {

            fontSize: '28px',
            marginBottom: '0px',
            [theme.breakpoints.down('sm')]: {
                fontSize: '22px'
            }
            
        },
        '& .edit-body': {
            [theme.breakpoints.down('sm')]: {
                fontSize: '16px'
            },
            color: 'white'
        }
    },
    progressTracker: {
        ...flexColumnCentered,
        position: 'fixed',
        top: '220px',
        width: '100vw',
        height: '50px',
        boxSizing: 'border-box',
        [theme.breakpoints.down('sm')]: {
            top: 'auto',
            bottom: '20px',
            
        },
        '& .inner-progress-container': {
            ...flexCentered,
            width: '90vw'
        },
        '& .MuiStepper-horizontal': {
            width: '90vw'
        },
        '& .MuiMobileStepper-root': {
            borderRadius: '30px',
            maxWidth: '90vw'
        }
    },
    editAllContainer : {
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '80%',
        maxWidth: '700px',
        marginTop: '90px',
        paddingBottom: '90px',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            maxWidth: '400px',
        }
    }

}

export default styles; 